import { Request, requestNoToken } from '../utils';

export const getStudentFiles = async (data) => {
  const result = await Request.get('digital-backpack/student-files', data);
  return result;
};
